/* Lonsmere: a barra de cookies nunca fica por cima de um botao de compra.
   Mede a altura dela, avisa a pagina e some enquanto a gaveta do carrinho ou um modal esta aberto. */
(function () {
  var ABERTO = 'cart-drawer.active, cart-drawer.drawer.animate.active, .product-modal.active, .drawer-content.active, .quick-view.active';
  var h = document.documentElement, raf = 0, lastPx = -1, lastOn = null, lastHide = null;
  function read() {
    raf = 0;
    var w = document.querySelector('.pd-cookie-banner-window.cc-window'), on = false, px = 0;
    if (w) {
      var cs = getComputedStyle(w);
      on = cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05 && !w.classList.contains('cc-invisible');
      if (on) px = Math.round(w.getBoundingClientRect().height);
    }
    var hide = false;
    try { hide = !!document.querySelector(ABERTO); } catch (e) {}
    if (px !== lastPx) { lastPx = px; h.style.setProperty('--lsf-cookie-h', px + 'px'); }
    var want = on && px > 0;
    if (want !== lastOn) { lastOn = want; h.classList.toggle('lsf-cookie-on', want); }
    if (hide !== lastHide) { lastHide = hide; h.classList.toggle('lsf-cookie-away', hide); }
  }
  function queue() { if (!raf) raf = requestAnimationFrame(read); }
  queue();
  try {
    new MutationObserver(queue).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style']});
  } catch (e) {}
  addEventListener('resize', queue);
  addEventListener('load', queue);
  addEventListener('orientationchange', queue);
  addEventListener('scroll', queue, {passive: true});
})();
